module.exports = __webpack_public_path__ + "static/media/landscape_1_3rule.96de46b2.jpg";